module.exports = __webpack_public_path__ + "components/home-header/static/header-4--small-94b6f2eef11089468d83f185a5205e5f.jpg";